<template>
  <div  v-loading="loading">
    <pt-page-title :title="`${isEdit ? '编辑' :'新建'}节假日`">
      <el-button type="primary" plain slot="on-right" @click="goNew" style="margin-left:20px">批量导入节假日
      </el-button>
    </pt-page-title>
    <pt-sub-title title="节假日信息"></pt-sub-title>
    <pt-holiday-form ref="form" v-model="currentForm" class="pt-holiday-form__withData"></pt-holiday-form>
    <div class="button-div">
        <el-button type="primary" @click="save">提交</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>

</template>

<script>
import { formatZero } from '@/utils/formUtils'
import PtHolidayForm from './index'
export default {
  name: 'pt-holiday-form__withData',
  components: {
    'pt-holiday-form': PtHolidayForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {

      }
    }
  },
  methods: {
    save () {
      this.form.validate().then(formValue => {
        this.loading = true
        this.isEdit ? this.edit() : this.create()
      })
    },
    goNew () {
      this.$router.push(`/holiday-excel-new/${this.$route.meta.type}`)
    },
    changeData (data) {
      let res = data.dates.map(e => {
        return {
          name: data.name,
          holidayType: data.holidayType,
          year: Number(e.split('-')[0]),
          month: Number(e.split('-')[1]),
          day: Number(e.split('-')[2])
        }
      })
      return res
    },
    async create () {
      let copyData = this.changeData(JSON.parse(JSON.stringify(this.currentForm)))
      let api
      switch (this.$route.meta.type) {
        case 'gene':
          api = 'createHoliday'
          break
        case 'sign':
          api = 'createHolidayOfSign'
          break
        default:
          api = 'createAdultHoliday'
          break
      }
      // let api = this.$route.meta.type === 'gene' ? 'createHoliday' : 'createAdultHoliday'
      this.$store.dispatch(api, copyData).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    async edit () {
      let copyData = this.changeData(JSON.parse(JSON.stringify(this.currentForm)))[0]
      copyData.id = this.$route.params.id
      let api
      switch (this.$route.meta.type) {
        case 'gene':
          api = 'editHoliday'
          break
        case 'sign':
          api = 'editHolidayOfSign'
          break
        default:
          api = 'editAdultHoliday'
          break
      }
      // let api = this.$route.meta.type === 'gene' ? 'editHoliday' : 'editAdultHoliday'
      this.$store.dispatch(api, copyData).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    changeToForm (data) {
      let copyData = JSON.parse(JSON.stringify(data))
      copyData.dates = [[copyData.year, formatZero(copyData.month, 2), formatZero(copyData.day, 2)].join('-')]
      return copyData
    },
    load () {
      this.loading = true
      let api
      switch (this.$route.meta.type) {
        case 'gene':
          api = 'getHoliday'
          break
        case 'sign':
          api = 'getHolidayDetail'
          break
        default:
          api = 'getAdultHoliday'
          break
      }
      // let api = this.$route.meta.type === 'gene' ? 'getHoliday' : 'getAdultHoliday'
      this.$store.dispatch(api, this.$route.params.id).then(data => {
        this.loading = false
        this.currentForm = this.changeToForm(data)
        console.log('this.currentForm---', this.currentForm)
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
